// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__UAhB_","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__PIY2b"};